import * as React from "react";
import { FunnelContainer } from "ui/funnelContainer/FunnelContainer";
import { CollectFunnelContext } from "components/collectFunnel/CollectFunnelProvider";
import { SET_PRODUCTS, NOT_A_PRODUCT_TYPE } from "components/collectFunnel/constants";
import useProductTypes from "hooks/useProductTypes";
import { STEP_DATE_URL, STEP_ADDRESS_URL } from "components/collectFunnel/constants";
import { useRouter } from "next/router";
import { useQuery } from "react-query";
import { useEffect } from "react";
import { CollectProductSelector } from "components/collect/CollectProductSelector";
import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { pushCollectionZoneNotServed } from "lib/gtm";

export const CollectFunnelProductChoiceStep = () => {
  const [state, dispatch] = React.useContext(CollectFunnelContext);
  const [noZone, setNoZone] = React.useState(null);
  const router = useRouter();
  const productTypes = useProductTypes({ is_collection_enabled: true });
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSelect = React.useCallback(
    (value, index) => {
      const getProducts = (value, index) => {
        let stateProducts = state.products;

        if (index < stateProducts.length) {
          stateProducts[index] = {
            type: productTypes.find((product) => product.id === value)?.name,
            id: value,
          };
        } else {
          stateProducts.push({
            type: productTypes.find((product) => product.id === value)?.name,
            id: value,
          });
        }
        return stateProducts;
      };
      const newProducts = getProducts(value, index);
      dispatch({
        type: SET_PRODUCTS,
        data: { products: newProducts },
      });
    },
    [dispatch, productTypes, state.products]
  );
  const deleteProduct = React.useCallback(
    (index) => {
      let stateProducts = state.products;
      stateProducts.splice(index, 1);

      dispatch({
        type: SET_PRODUCTS,
        data: { products: stateProducts },
      });
    },
    [dispatch, state.products]
  );

  const handleNextStep = React.useCallback(() => {
    router.push(STEP_DATE_URL, undefined, { shallow: true });
  }, [router]);

  const handlePreviousStep = React.useCallback(() => {
    router.push(STEP_ADDRESS_URL, undefined, { shallow: true });
  }, [router]);

  useQuery(
    [
      "common/areas",
      {
        postal_code: state.postalCode,
        collection: true,
      },
    ],
    {
      onSuccess: (data) => {
        if (data && data.length === 0) {
          setNoZone(true);
          pushCollectionZoneNotServed(state.postalCode);
        }
      },
    }
  );

  const addProduct = React.useCallback(() => {
    dispatch({
      type: SET_PRODUCTS,
      data: {
        products: [
          ...state.products,
          {
            type: NOT_A_PRODUCT_TYPE,
            id: 0,
          },
        ],
      },
    });
  }, [dispatch, state.products]);

  useEffect(() => {
    if (state.products.length === 0) {
      addProduct();
    }
  }, [state.products, addProduct]);

  return (
    <FunnelContainer>
      <Box mt={isTablet ? 2 : 5} p={3}>
        {state?.products && state.products[0] && (
          <CollectProductSelector
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
            noZone={noZone}
            handleSelect={handleSelect}
            deleteProduct={deleteProduct}
            productsToCollect={state.products}
            addProduct={addProduct}
            productTypes={productTypes}
            isCollectFunnel
          />
        )}
      </Box>
    </FunnelContainer>
  );
};
